import ArrowLeftIcon from '@heroicons/react/outline/ArrowLeftIcon'
import { useLocation } from 'react-router'
import { Link, matchPath } from 'react-router-dom'

import { Button } from '@tribeplatform/react-ui-kit/Button'
import { NavVertical } from '@tribeplatform/react-ui-kit/Sidebar'

import { SidebarItem } from './sidebars'

export const NestedSidebarContent = ({ sidebar }: { sidebar: SidebarItem }) => {
  const location = useLocation()

  const findDeepestMatchingRoute = (item: SidebarItem): SidebarItem | null => {
    const matching = item.children?.find(item => {
      return matchPath(location.pathname, {
        path: item.path,
        exact: item.exact || false,
        strict: false,
      })
    })
    if (matching?.children) {
      return findDeepestMatchingRoute(matching)
    }
    if (matching) {
      return matching
    }
    return item
  }

  const activeItem = findDeepestMatchingRoute(sidebar)
  if (!activeItem) {
    return null
  }

  return (
    <NavVertical className="p-3 pt-5">
      <NavVertical.Group>
        <div className="space-y-5">
          <Button
            variant="outline"
            rounded
            as={Link}
            to="/manage/editor"
            leadingIcon={<ArrowLeftIcon />}
          />
          <div>
            <h3 className="px-2 text-basicMain-900">{activeItem?.title}</h3>
            {activeItem?.description ? (
              <p className="px-2 text-sm text-basicMain-400">
                {activeItem?.description}
              </p>
            ) : null}
          </div>
        </div>
        <div className="px-2 pt-3 space-y-1 flex flex-col">
          {activeItem.component
            ? activeItem.component
            : activeItem?.children?.map(item => {
                const active = matchPath(location.pathname, {
                  path: item.path,
                  exact: true,
                  strict: false,
                })
                return (
                  <NavVertical.Item
                    key={item.path}
                    active={!!active}
                    as={Link}
                    leadingIcon={item.icon}
                    to={item.path}
                  >
                    {item.title}
                  </NavVertical.Item>
                )
              })}
        </div>
      </NavVertical.Group>
    </NavVertical>
  )
}
